/* eslint-disable no-continue */
/* eslint-disable no-labels */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */

export const severityValues = ['Light', 'Medium', 'Severe'];
// const severityColors = ['#222', '#7ba428', '#FFC90E', '#ff1a1a', '#222'];
export const severityStyles = ['light', 'medium', 'heavy'];
export function removeSelectedPanel(selPartID) {
  const gwElement = getGWElement();
  if (gwElement) {
    const newPartList = JSON.parse(gwElement.value).parts.filter((part) => part.id !== selPartID);
    gwElement.value = JSON.stringify({ parts: newPartList });
  }
}

export function setPartColor(selPartID, severity, isModal = false) {
  let selectedPartElement = null;
  if (isModal && document.querySelector('.modal-img svg')) {
    const arr = Array.from(document.querySelector('.modal-img svg')?.children).filter((node) => node.id === selPartID);
    [selectedPartElement] = arr;
  } else { selectedPartElement = document.getElementById(selPartID); }
  if (selectedPartElement) {
    const severityIdx = severityValues.indexOf(severity);
    const severityStyle = severityStyles[severityIdx];
    for (let i = 0; i < selectedPartElement.childNodes.length; i += 1) {
      const child = selectedPartElement.childNodes[i];
      if (child.className && child.className.baseVal && child.className.baseVal.indexOf('state') >= 0) {
        for (i in severityStyles) {
          child.className.baseVal = child.className.baseVal.replace(severityStyles[i], '');
          // child.classList.remove(severityStyles[i]);
        }
        child.className.baseVal += ` ${severityStyle}`;
      }
    }
  }
}

export function getGWElement() {
  const gwElement = document.getElementsByName('AudaTargetVehDamage_EcoPopup-DamageText')[0];
  return gwElement;
}

export function AudaTargetScript(setShowModal, setSelectedPartModal, intl) {
  let damagedParts = null;
  let selectedPartID = null;
  let severitySlider = null;
  let severityLabel = null;
  function updateSlider(event) {
    if (event.target !== undefined) {
      setSliderValue(event.target.value);
    }
  }

  function setSliderValue(value) {
    const selectedSeverity = severityValues[value];
    severityLabel.innerHTML = intl.formatMessage({ id: `Damage Severity: ${selectedSeverity}`, defaultValue: `Damage Severity: ${selectedSeverity}` });
    if (selectedPartID) {
      if (selectedSeverity) {
        let selectedPart = getSelectedPart(selectedPartID);
        if (selectedPart == null) {
          selectedPart = JSON.parse(`{"id" : "${selectedPartID}", "severity": "${selectedSeverity}"}`);
          damagedParts.parts.push(selectedPart);
        }
        selectedPart.severity = selectedSeverity;
      } else {
        removeSelectedPart(selectedPartID);
      }
    }

    for (const i in damagedParts.parts) {
      const part = damagedParts.parts[i];
      setPartColor(part.id, part.severity, true);
    }
    document.getElementById('modal-save-button').onclick = () => {
      const gwElem = getGWElement();
      if (gwElem) {
        gwElem.value = JSON.stringify(damagedParts);
      }
    };
    setPartColor(selectedPartID, selectedSeverity, true);
  }
  function setSlider(value) {
    severitySlider.value = value;
    setSliderValue(value);
  }
  function areaClicked(e) {
    const containerElement = getContainer(e.target);
    if (containerElement && isValidPart(containerElement)) {
      setShowModal(true);
    }
    if (!severitySlider && !severityLabel) {
      severitySlider = document.getElementById('severitySlider');
      severityLabel = document.getElementById('severityLabel');
      if (severitySlider) {
        severitySlider.addEventListener('change', updateSlider);
      }
    }
    if (containerElement && isValidPart(containerElement)) {
      deselectAllParts();
      selectedPartID = containerElement.id;
      setSelectedPartModal(selectedPartID);
      initPart(selectedPartID);
    }
  }
  function getContainer(node) {
    if (!node) {
      return null;
    }
    if (node.tagName === 'svg') {
      return null;
    }
    if (node.tagName === 'g' && node.id) {
      return node;
    }
    return getContainer(node.parentNode);
  }
  function isValidPart(elm) {
    const { children } = elm;
    for (const c in children) {
      if ((children[c].classList?.contains('state') || children[c].classList?.contains('car')) && (!children[c].classList?.contains('disabled'))) {
        return true;
      }
    }
    return false;
  }
  function getSelectedPart(selPartID) {
    for (const i in damagedParts.parts) {
      const part = damagedParts.parts[i];
      if (part.id === selPartID) {
        return part;
      }
    }
    return null;
  }
  function deselectAllParts() {
    const allParts = document.querySelector('.audatarget-container svg').children;
    partsLoop:
    for (let i = 0; i < allParts.length; i += 1) {
      if (allParts[i]) {
        for (let k = 0; k < damagedParts.parts.length; k += 1) {
          if (damagedParts.parts[k].id === allParts[i].id) {
            continue partsLoop;
          }
        }
        const part = allParts[i];
        for (let j = 0; j < part.childNodes.length; j += 1) {
          const child = part.childNodes[j];
          if (child && child.classList) {
            child.classList.remove('active');
          }
        }
      }
    }
  }
  function removeSelectedPart(selPartID) {
    for (const i in damagedParts.parts) {
      const part = damagedParts.parts[i];
      if (part.id === selPartID) {
        damagedParts.parts.splice(i, 1);
      }
    }
  }

  function initPart(selectedpartid) {
    const selectedPart = getSelectedPart(selectedpartid);
    if (selectedPart != null) {
      const idx = severityValues.indexOf(selectedPart.severity);
      setSlider(idx);
    } else {
      setSlider(1);
    }
  }
  function registerClickEvent() {
    const svgElement = document.querySelector('.audatarget-container svg');
    if (svgElement) {
      svgElement.addEventListener('click', areaClicked);
    }
  }
  function initializeImage() {
    // get var damagedParts from GW element
    let damagedPartsText = '{"parts": []}';
    const gwElement = getGWElement();
    if (gwElement !== undefined && gwElement != null) {
      damagedPartsText = gwElement.value;
      gwElement.classList.add('gw-hidden');
      gwElement.onclick = false;
    }
    // Initialize slider if no part is selected
    severitySlider = document.getElementById('severitySlider');
    severityLabel = document.getElementById('severityLabel');
    if (severitySlider && severityLabel) {
      severitySlider.value = 1;
      severityLabel.value = intl.formatMessage({ id: 'Damage Severity:', defaultValue: 'Damage Severity:' });
    }

    // This is a workaround for missing selection style classes in the svg coming from Audatarget
    initializeStyles();
    // init colors of all parts with damage
    damagedParts = JSON.parse(damagedPartsText);
    for (const i in damagedParts.parts) {
      const part = damagedParts.parts[i];
      setPartColor(part.id, part.severity, false);
    }
    registerClickEvent();
  }
  function initializeStyles() {
    const svgElements = document.querySelector('.audatarget-container svg');
    svgElements.setAttribute('height', '600px');
    for (let svgIdx = 0; svgIdx < svgElements.length; svgIdx += 1) {
      // This is a workaround for the pick-up scrolling issue, the pickup svg is also lacking an id,
      // therefore we try to identify it by its front grill container
      const pickupFrontGrillElement = document.getElementById('Front_Grill');
      if (pickupFrontGrillElement) {
        svgElements[svgIdx].setAttribute('height', '900px');
      }
    }
  }
  initializeImage();
}
